import { isPresent } from 'utils/isPresent';
import React, { useState, useCallback, memo } from 'react'
import { compose } from 'redux'
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid'
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles'
import EmployeesListPopover from './EmployeesListPopover.jsx'
import ServiceProField from './ServiceProField.jsx'
import AddEmployeeButton from './AddEmployeeButton.jsx'

const styles = theme => ({
  button: {
    width: '100%',
    color: theme.palette.secondary.light,
    textTransform: 'none',
  },
  buttonText: {
    color: theme.palette.secondary.light,
  },
  textField: {
    width: '100%',
  },
  textFieldContainer: {
    width: '90%',
    padding: 8,
  },
  avatar: {
    marginLeft: -7,
    marginRight: 17,
    width: 38,
    height: 38,
  },
  clearIcon: {
    color: theme.palette.secondary.light,
  },
})

const CreateUpdateServiceProSelection = ({
  classes,
  selectedServicePro,
  onEmployeeChange,
  servicePros,
}) => {
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)

  const openPopOver = useCallback(event => {
    setOpen(true)
    setAnchorEl(event.currentTarget)
  }, [])

  const closePopOver = useCallback(() => {
    setOpen(false)
    setAnchorEl(null)
  }, [])

  const handleServiceProSelection = useCallback(
    servicePro => {
      closePopOver()
      onEmployeeChange(servicePro)
    },
    [onEmployeeChange]
  )

  const handleEmployeeChange = useCallback(() => onEmployeeChange({}), [
    onEmployeeChange,
  ])

  return (
    <Grid
      container
      item
      className={classes.textFieldContainer}
      alignItems="center"
      justify="flex-start"
      wrap="nowrap"
      xs={12}
    >
      {isPresent(selectedServicePro) ? (
        <ServiceProField
          classes={classes}
          selectedServicePro={selectedServicePro}
          onClick={openPopOver}
          onIconButtonClick={handleEmployeeChange}
        />
      ) : (
        <AddEmployeeButton classes={classes} onClick={openPopOver} />
      )}
      <EmployeesListPopover
        open={open}
        onClose={closePopOver}
        anchorEl={anchorEl}
        servicePros={servicePros}
        onSelect={handleServiceProSelection}
      />
    </Grid>
  )
}

export default compose(
  withStyles(styles),
  memo
)(CreateUpdateServiceProSelection)
